
import React from 'react'
import calendar from '@/assets/calendar.svg'
import { useTranslation } from "react-i18next";

type WorkingHoursType = {
    workingHours: {
        isActive: boolean
        timeFrom: string
        timeTill: string
    }[]
}

const WorkingHours: React.FC<WorkingHoursType> = ({ workingHours }) => {
    const { t } = useTranslation(["glossary"]);

    const getDay = (index: number) => {

        switch (index) {
            case 0: return t("monday", { ns: "glossary" })
            case 1: return t("tuesday", { ns: "glossary" });
            case 2: return t("wednesday", { ns: "glossary" });
            case 3: return t("thursday", { ns: "glossary" });
            case 4: return t("friday", { ns: "glossary" });
            case 5: return t("saturday", { ns: "glossary" });
            case 6: return t("sunday", { ns: "glossary" });
            default: return null
        }
    }

    return (
        <div className='flex flex-row items-start gap-4'>
            <img src={calendar} />
            <ul className='space-y-2 text-sm'>

                {workingHours.map((item, ind) => (
                    <li className='flex flex-row'>

                        <div className='w-24'>{getDay(ind)}</div>
                        <div>:</div>
                        {item.isActive ? (
                            <div className='ml-6'>
                                {item.timeFrom} - {item.timeTill}
                                {item.hasFlexibleHours && item.flexTimeFrom && item.flexTimeTill && (
                                    `, ${item.flexTimeFrom} - ${item.flexTimeTill}`
                                )}
                            </div>
                        ) : (
                            <div className='ml-6'>{t("closed", { ns: "glossary" })}</div>
                        )}


                    </li>
                ))}
            </ul>
        </div>

    )
}

export default WorkingHours
